import dayjs from "dayjs";

export const dayFormat = time => {
  return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
};
export const dayFormatYMD = time => {
  return dayjs(time).format("YYYY-MM-DD");
};
export const cheatPer = val => {
  return (val * 100).toFixed(2) + "%";
};
